import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ChartComponent} from "ng-apexcharts";
import {ChannelDefinition} from "../../../../model/channels.model";
import {DecisionsService} from "../../decisions.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {ChartOptions} from "../../../../app.module";

@Component({
  selector: 'admin-decisions-model-evolution',
  templateUrl: './evolution.component.html',
  styleUrls: ['./evolution.component.css']
})
export class EvolutionComponent implements OnInit {
  @ViewChild("chart") chart: ChartComponent;

  @Input() channel: ChannelDefinition = new ChannelDefinition();

  public engineChart: Partial<ChartOptions>
  public decisionChart: Partial<ChartOptions>

  public commonOptions: Partial<ChartOptions> = {
    chart: {
      height: 250,
      zoom: {
        enabled: false
      }
    },
    fill: {
    },
    colors: ["#0066ff", "#ff0000"],
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "straight"
    },
    toolbar: {
      tools: {
        selection: false
      }
    },
    markers: {
      size: 5,
      hover: {
        size: 10
      }
    },
    grid: {
      show: true,
      strokeDashArray: 1,
      position: 'back',
      yaxis: {
        lines: {
          show: true
        }
      },
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5
      },
    },
    xaxis: {
      labels: {
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
        style: {
          fontSize: '10px',
        },
      }
    },
    yaxis: {
      min: 0.000,
      max: 1.000,
      labels: {
        formatter: function (value) {
          return value.toFixed(3);
        }
      },
    },
    legend: {
      fontSize: '12px',
      show: true,
    }
  };

  constructor(
    private service: DecisionsService,
    private viewManager: ViewManagerService
  ) {
    this.engineChart = {
      series: [],
      title: {
        text: "engine contour"
      },
      labels: []
    };
    this.decisionChart = {
      series: [],
      title: {
        text: "decision contour"
      },
      labels: []
    };
  }

  ngOnInit(): void {
    this.service.evolution(this.channel.config!, "engine")
      .pipe()
      .subscribe({
        next: (result) => {
          this.engineChart.series = [
            {name: "P(true|+)", data: result['true_positive'], type: 'line'},
            {name: "P(false|+)", data: result['false_positive'], type: 'line'},
          ];
          this.engineChart.labels! = result['categories']
        },
        error: error => {
          console.log(error);
        }
      });

    this.service.evolution(this.channel.config!, "decision")
      .pipe()
      .subscribe({
        next: (result) => {
          this.decisionChart.series = [
            {name: "P(true|+)", data: result['true_positive'], type: 'line'},
            {name: "P(false|+)", data: result['false_positive'], type: 'line'},
          ];
          this.decisionChart.labels! = result['labels']
        },
        error: error => {
          console.log(error);
        }
      });
  }
}
